import helpers from './methods'

function hslStringToHex (hslString) {
  const match = hslString.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
  let [, h, s, l] = match.map(Number);

  return hslToHex(h, s, l);
}

function hslToHex (h, s, l) {
  s /= 100;
  l /= 100;

  function f(n) {
      const k = (n + h / 30) % 12;
      const a = s * Math.min(l, 1 - l);
      const c = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
      return Math.round(c * 255).toString(16).padStart(2, '0');
  }

  return `#${f(0)}${f(8)}${f(4)}`;
}

export default {
  methods: {
    timeToString (milliseconds) {
      if (!milliseconds) {
        return '00:00:00'
      }

      const totalSeconds = Math.floor(milliseconds / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      return [hours, minutes, seconds]
          .map(unit => String(unit).padStart(2, '0'))
          .join(':')
    },
    formatString (string) {
      const words = string.replace(/\[(.+?)\]/, '').split('_');

      return words.map(word =>
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ')
    },
    generateColorsByLength (count) {
      return Array.from({ length: count }, (_, i) => hslStringToHex(`hsl(${Math.floor((i * 360 / count) % 360)}, 70%, 50%)`))
    },
    copyToClipboard: helpers.copyToClipboard.bind(this)
  }
}